export const PAGES_MENU_ADMIN = [
    {
        path: 'pages',
        children: [
            {
                path: 'dashboard',
                data: {
                    menu: {
                        title: 'menu.dashboard',
                        icon: 'ion-android-home',
                        selected: false,
                        expanded: false,
                        order: 0
                    }
                }
            },
            {
                path: 'change-password',
                data: {
                    menu: {
                        title: 'menu.change-password',
                        hidden: true,
                    }
                }
            },
            {
                path: 'users',
                data: {
                    menu: {
                        title: 'menu.users',
                        icon: 'ion-person-stalker',
                    }
                },
                children: [
                    {
                        path: 'regular-users',
                        data: {
                            menu: {
                                title: 'menu.users_list',
                                icon: 'ion-person-stalker',
                            },
                        },
                    },
                    {
                        path: 'add',
                        data: {
                            menu: {
                                title: 'menu.add_user',
                                icon: 'ion-person-add',
                            },
                        },
                    },

                    {
                        path: 'devices',
                        data: {
                            menu: {
                                title: 'menu.devices',
                                icon: 'ion-android-phone-portrait',
                            },
                        },
                    }
                ],
            },
            {
                path: 'notifications',
                data: {
                    menu: {
                        title: 'menu.notifications',
                        icon: 'ion-ios-bell',
                        selected: false,
                        expanded: false,
                        order: 0
                    }
                },
                children: [
                    {
                        path: 'list',
                        data: {
                            menu: {
                                title: 'menu.notifications_list',
                                icon: 'ion-ios-bell',
                            },
                        },
                    },
                    {
                        path: 'add',
                        data: {
                            menu: {
                                title: 'menu.add_notification',
                                icon: 'ion-plus-round',
                            },
                        },
                    },
                    {
                        path: 'settings',
                        data: {
                            menu: {
                                title: 'menu.notifications_settings',
                                icon: 'ion-ios-settings',
                            },
                        },
                    },
                ],
            },
            {
                path: 'transactions',
                data: {
                    menu: {
                        title: 'menu.transactions',
                        icon: 'ion-ios-paper',
                        selected: false,
                        expanded: false,
                        order: 0
                    }
                },
                children: [
                    {
                        path: 'list',
                        data: {
                            menu: {
                                title: 'menu.transactions_list',
                                icon: 'ion-ios-paper',
                            },
                        },
                    },
                    {
                        path: 'initialized-payments',
                        data: {
                            menu: {
                                title: 'menu.initialized_payments',
                                icon: 'ion-ios-paper',
                            },
                        },
                    },
                ],
            },
            {
                path: 'comments',
                data: {
                    menu: {
                        title: 'menu.praises_remarks',
                        icon: 'ion-clipboard',
                        selected: false,
                        expanded: false,
                        order: 0
                    }
                },
                children: [
                    {
                        path: 'list',
                        data: {
                            menu: {
                                title: 'menu.praises_remarks_list',
                                icon: 'ion-clipboard',
                            },
                        },
                    },
                ],
            },
        ]
    }
];




// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/pages/pages.menu.ts